import { useEffect, useState } from "react";
import { api } from "./api";

// The rate from Settings > Pricing ("USD rate per 1k Robux"), shared by every
// screen that shows dollars. Until it loads it falls back to the same default
// the Settings page shows.
export const DEFAULT_USD_RATE = 5;

let store = { token: null, rate: null };
const listeners = new Set();

const valid = (v) => {
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : null;
};

// Call after saving Settings so every open screen updates without a reload.
export function setUsdRate(token, value) {
  const n = valid(value);
  if (n === null) return;
  store = { token, rate: n };
  listeners.forEach((fn) => fn(n));
}

export function useUsdRate(token) {
  const [rate, setRate] = useState(store.token === token && store.rate !== null ? store.rate : DEFAULT_USD_RATE);
  useEffect(() => {
    listeners.add(setRate);
    if (store.token === token && store.rate !== null) {
      setRate(store.rate);
    } else {
      api.getConfig(token)
        .then((cfg) => setUsdRate(token, valid(cfg && cfg.USDRatePer1k) ?? DEFAULT_USD_RATE))
        .catch(() => {});
    }
    return () => { listeners.delete(setRate); };
  }, [token]);
  return rate;
}
